import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import App from "./App";
import Footer from "./components/Footer";
import TopButton from "./components/TopButton";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <TopButton />
        <Footer />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);